import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(_vm.isShowLoader)?_c('loader',{attrs:{"object":"#3dd598","color1":"#ffffff","color2":"#17fd3d","size":"11","speed":"1","bg":"#343a40","objectbg":"#999793","opacity":"80","disable-scrolling":"false","name":"spinning"}}):_vm._e(),(_vm.isAuth)?_c('AppHeader'):_vm._e(),_c('TheModals'),(_vm.isAuth)?_c('navigation'):_vm._e(),_c(VMain,[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }